import React from 'react';
import {useFormik} from "formik";
import {
    Button,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";
import DocumentsTreeView from "../DocumentsTreeView/DocumentsTreeView.jsx";
import FolderOpenIcon from "@material-ui/icons/FolderOpen.js";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined.js";
import {useDialog} from "../../hooks/useDialog.js";
import * as yup from "yup";

const validationSchema = yup.object().shape({
    description: yup.string().required('Ссылка не может быть пустой'),
    normative_document: yup.number().required('Выберите документ')
})

const HandbookDialog = (props) => {
    const {open, onClose, folderNodes, documents, submitCallback} = props

    const collapseTransition = useDialog()

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const onSubmit = async (values) => {
        await submitCallback(values)
        handleCloseDialog()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
    }

    const {getFieldProps, resetForm, submitForm, setFieldValue, errors} = useFormik({
        initialValues: {
            handbook: undefined,
            description: '',
            normative_document: undefined
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit
    })

    const typeIcons = {
        folder: FolderOpenIcon,
        normativeDocument: DescriptionOutlinedIcon
    }

    const iconTooltips = {
        folder: 'Папка',
        normativeDocument: 'Документ'
    }

    const toolbarCallbacks = {
        onDoubleClick: (nodeID) => async () => {
            const [type, id] = nodeID.split('.')
            if (type === 'normativeDocument') {
                await setFieldValue('normative_document', parseInt(id))
                collapseTransition.handleClose()
            }
        }
    }

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"md"} fullWidth>
            <DialogTitle>Добавить ссылку</DialogTitle>
            <DialogContent>
                <Grid container direction={'column'} spacing={2}>
                    {Object.values(errors).map(error => <Grid item><Typography
                        color={'error'}>{error}</Typography></Grid>)}
                    <Grid item>
                        <TextField
                            fullWidth
                            name={'description'}
                            label={'Введите ссылку ($number - номер пункта)'}
                            {...getFieldProps('description')}/>
                    </Grid>
                    <Grid item container alignItems={'center'} spacing={2}>
                        <Grid item xs>
                            <Typography>{
                                documents.find(doc => doc.id === parseInt(getFieldProps('normative_document').value))?.name
                            }</Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                onClick={collapseTransition.handleOpen}
                                variant={'outlined'}
                            >
                                Выбрать документ
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Collapse in={collapseTransition.open}>
                            <Paper variant={'outlined'}>
                                <DocumentsTreeView
                                    nodes={folderNodes}
                                    typeIcons={typeIcons}
                                    iconTooltips={iconTooltips}
                                    toolbarCallbacks={toolbarCallbacks}
                                    hideToolbar
                                />
                            </Paper>
                        </Collapse>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HandbookDialog;